import { Service, inject } from '@angular/core'
import {
  EditEntityBody,
  EntityPost,
  EntitySetupCompletion,
  ManagedEntity,
  PutEntityPostBody,
  SetEntityPaymentSettingsBody,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class ManageEntityApiService {
  private readonly api = inject(ApiService)

  getManagedEntity(entityId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedEntity>(`manage/entities/${entityId}`, { ...init })
  }

  getSetupCompletion(entityId: string, init?: RequestInit) {
    return this.api.protectedFetchJson<EntitySetupCompletion>(`manage/entities/${entityId}/completion`, { ...init })
  }

  editEntity(entityId: string, body: EditEntityBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedEntity>(`manage/entities/${entityId}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
      ...init,
    })
  }

  setEntityPaymentSettings(entityId: string, body: SetEntityPaymentSettingsBody, init?: RequestInit) {
    return this.api.protectedFetchJson<ManagedEntity>(`manage/entities/${entityId}/payment-settings`, {
      method: 'PUT',
      body: JSON.stringify(body),
      ...init,
    })
  }

  saveEntityPost(entityId: string, body: PutEntityPostBody, init?: RequestInit) {
    return this.api.protectedFetchJson<EntityPost>(`manage/entities/${entityId}/post`, {
      method: 'PUT',
      body: JSON.stringify(body),
      ...init,
    })
  }
}
